export default "__VITE_ASSET__Dx3W6mZ7__"